module.exports = __webpack_public_path__ + "static/arcadium-prod-alt-gorsel-cba3bff86e16d4583202cdab8ec9adbe.webp";